import {mutate} from "swrv";
import useSwr from "@/core/composables/swr/useSwr";
import {featureHighlightApi} from "@/container";

const currentFeatureHighlightKey = 'feature-highlights';

const fetchCurrentFeatureHighlight = () => {
    return featureHighlightApi().index(true, {limit: 1});
};

/**
 * SWR composable to fetch the current feature highlight.
 */
const useCurrentFeatureHighlight = () => {
    return useSwr(currentFeatureHighlightKey, fetchCurrentFeatureHighlight);
};

/**
 * Refetch the current feature highlight in the cache, so the next visit of the
 * home does not render an outdated email alert.
 */
export const refreshCurrentFeatureHighlight = () => {
    return mutate(currentFeatureHighlightKey, fetchCurrentFeatureHighlight());
};

export default useCurrentFeatureHighlight;
